import { jsx as e } from "react/jsx-runtime";
import * as a from "react";
import { R as c, I as t, a as l } from "../../index-CFMMNAmh.js";
import { c as s } from "../../cn-gv_k3DnN.js";
import { focusRing as b } from "../../utils/focus-ring.js";
const n = a.forwardRef(({ className: r, hasError: o, ...d }, i) => /* @__PURE__ */ e(
  c,
  {
    className: s("gap-sp-3 group grid", r),
    "data-state": o ? "error" : void 0,
    ...d,
    ref: i
  }
));
n.displayName = c.displayName;
const h = a.forwardRef(({ className: r, ...o }, d) => /* @__PURE__ */ e(
  t,
  {
    ref: d,
    className: s(
      b,
      // Base
      "size-s-3 peer relative aspect-square rounded-full border border-(--color-radio-stroke-unchecked)",
      // Checked
      "data-[state=checked]:border-(--color-radio-bg-checked) data-[state=checked]:bg-(--color-radio-bg-checked) data-[state=checked]:hover:border-(--color-radio-bg-checked-hover) data-[state=checked]:hover:bg-(--color-radio-bg-checked-hover)",
      // Hover
      "hover:bg-(--color-radio-bg-unchecked-hover)",
      // Disabled
      "disabled:border-(--color-radio-stroke-unchecked-disabled) disabled:bg-(--color-radio-bg-unchecked-disabled) data-[state=checked]:disabled:border-(--color-radio-bg-checked-disabled) data-[state=checked]:disabled:bg-(--color-radio-bg-checked-disabled) disabled:pointer-events-none",
      // Error
      "group-data-[state=error]:border-action-stroke-input-danger-active",
      r
    ),
    ...o,
    children: /* @__PURE__ */ e(l, { className: "flex items-center justify-center", children: /* @__PURE__ */ e("div", { className: "size-s-1 bg-(--color-radio-content-checked) group-data-[disabled]:bg-(--color-radio-content-checked-disabled) rounded-full" }) })
  }
));
h.displayName = t.displayName;
export {
  n as RadioGroup,
  h as RadioGroupItem
};
